export default __webpack_public_path__ + "static/media/ic_close.902f11b1.svg";